import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { api, ApiError } from '../api';
import { t } from '../i18n';

export function LoginPage({ setup }: { setup: boolean }) {
  const qc = useQueryClient();
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      if (setup) await api.setup(name, password);
      else await api.login(name, password);
      await qc.invalidateQueries({ queryKey: ['auth'] });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="center-screen">
      <form className="card auth" onSubmit={submit}>
        <h1>
          <span className="logo">▤</span> {t('app.name')}
        </h1>
        {setup && (
          <>
            <h2>{t('auth.setupTitle')}</h2>
            <p className="muted">{t('auth.setupIntro')}</p>
          </>
        )}
        <label>
          {t('common.name')}
          <input autoFocus autoComplete="username" value={name} onChange={(e) => setName(e.target.value)} required />
        </label>
        <label>
          {t('common.password')}
          <input
            type="password"
            autoComplete={setup ? 'new-password' : 'current-password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={setup ? 10 : 1}
            required
          />
          {setup && <span className="muted small">{t('auth.passwordHint')}</span>}
        </label>
        {error && <div className="error">{error}</div>}
        <button className="primary" disabled={busy}>
          {setup ? t('auth.setupSubmit') : t('auth.login')}
        </button>
      </form>
    </div>
  );
}
